import { render, staticRenderFns } from "./CoBrandedPageCustomer.vue?vue&type=template&id=5a556d51&"
import script from "./CoBrandedPageCustomer.vue?vue&type=script&lang=js&"
export * from "./CoBrandedPageCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CoBrandedPageCustomer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports